import type { PlyrSource } from 'plyr-react';

export const VIDEO_SOURCE: PlyrSource = {
    type: 'video',
    title: 'Newo Partner Introduction',
    sources: [
        {
            src: 'https://storage.googleapis.com/newo-static-files/partner-videos/Partner%20Portal%20Video(1).mp4',
            type: 'video/mp4'
        }
    ]
};

export const VIDEO_OPTIONS = {
    autoplay: true,
    muted: true,
    ratio: '16:9',
    controls: [
        'play-large',
        'play',
        'progress',
        'current-time',
        'mute',
        'volume',
        'settings',
        'fullscreen'
    ],
    attributes: {
        autoplay: true,
        muted: true,
        playsInline: true
    }
};
